import {IHttpPromise, IHttpService, IPromise} from "angular";
import {Page, Pageable} from "../../utils/models/Page";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {SendGridContactListOptions} from "../../customers/model/SendGridContactListOptions";
import {ContactFilter} from "../../contact/model/ContactFilter";
import {IContactService} from "../../contact/service/IContactService";
import {Lead} from "../model/Lead";

export class LeadService implements IContactService<Lead> {

    static instance = [
        '$http',
        LeadService
    ]

    constructor(private $http: IHttpService) {
    }


    fetchContacts(filter: ContactFilter, pagingConfig: Pageable): IHttpPromise<Page<Lead>> {
        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/leads/'),
            data: filter,
            params: {
                pageSize: pagingConfig.pageSize,
                pageNumber: pagingConfig.page - 1
            }
        });
    }

    createSendgridContactsListFromFilteredContacts = (sendGridOptions: SendGridContactListOptions,
                                                   filter: ContactFilter) => this.$http({
        method: 'POST',
        url: getAbsoluteUrl('api/lead/contact_list'),
        data: {
            sendGridOptions: sendGridOptions,
            contactFilter: filter
        },
        params: {
            filtered: true
        }
    });

    createSendgridContactsListFromContactIds = (sendGridOptions: SendGridContactListOptions, ids: number[]) =>
        this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/lead/contact_list'),
            data: {
                sendGridOptions: sendGridOptions,
                ids: ids
            },
            params: {
                personal: true
            }
        });

    fetchContactDetails(id: number): IPromise<Lead> {
        return this.$http<Lead>({
            method: 'GET',
            url: getAbsoluteUrl(`api/lead/${id}`)
        }).then(r => r.data);
    }
}